module.exports = __webpack_public_path__ + "img/card_cooperacion.75c7e54c.jpg";